import _toConsumableArray from "/Users/dream/Desktop/work/project/jihuiduo-member-h5/node_modules/@babel/runtime-corejs2/helpers/esm/toConsumableArray";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import serviceApi from '@/service';
import bottom from '@/components/nomore';
import goodsItem from '@/components/goodsItem';
import QuickNav from '@/components/QuickNav';
export default {
  data: function data() {
    return {
      page: 1,
      pageSize: 20,
      total: 0,
      list: [],
      loading: false,
      finished: false,
      isNodata: false,
      refreshing: false
    };
  },
  components: {
    bottom: bottom,
    'goods-item': goodsItem,
    'quick-nav': QuickNav
  },
  mounted: function mounted() {
    console.log(this.$route.query);
    this.getList();
  },
  methods: {
    getList: function getList() {
      var _this = this;

      var isMore = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var isRefresh = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (isMore) {
        if (this.list.length >= this.total) {
          this.finished = true;
          return;
        }
      }

      if (isRefresh) this.refreshing = true;
      var param = {
        currentPage: this.page,
        pageSize: this.pageSize
      };
      serviceApi.getNewerSkuList(param).then(function (res) {
        if (res.message == 'OK') {
          var oldList = JSON.parse(JSON.stringify(_this.list));
          if (isMore) _this.list = [].concat(_toConsumableArray(oldList), _toConsumableArray(res.result.data));else _this.list = res.result.data;

          if (_this.list.length >= _this.total) {
            _this.finished = true;
            return;
          }

          _this.page++;
        }
      }).finally(function () {
        // 处理loading等信息逻辑
        if (isRefresh) _this.refreshing = false;
      });
    },
    gotoDetail: function gotoDetail(saleSkuId) {
      this.$router.push({
        path: '/detail',
        query: {
          saleSkuId: saleSkuId,
          categoryId: this.$route.query.saleCategoryId
        }
      });
      this.$service.getStatisCommon("evn_close_page", {});
    }
  }
};